export const iconFontAwesomeHumanitarianPersonWalkingLuggage = (
	<i className="fa-solid fa-person-walking-luggage"></i>
);
